var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIc2Arrow = function SvgIc2Arrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19 12.6a.613.613 0 0 1-.19-.442v-.316a.63.63 0 0 1 .19-.442l4.452-4.277a.442.442 0 0 1 .615 0l.615.592a.4.4 0 0 1 0 .584L7.018 12l3.854 3.701a.41.41 0 0 1 0 .592l-.615.584a.442.442 0 0 1-.615 0L5.191 12.6ZM12.19 12.6a.614.614 0 0 1-.19-.442v-.316a.63.63 0 0 1 .19-.442l4.452-4.277a.442.442 0 0 1 .615 0l.615.592a.4.4 0 0 1 0 .584L14.018 12l3.854 3.701a.41.41 0 0 1 0 .592l-.615.584a.442.442 0 0 1-.615 0L12.191 12.6Z"
  })));
};
export default SvgIc2Arrow;